<template>
  <ModalComponent
    :model-value="showRef"
    :close="handleCloseModal"
    :max-width="38"
    :style-class-contain="styleClassContain"
  >
    <ModalHeader
      :is-header="`no__header`"
      style="z-index: 10"
      title=""
      @close="handleCloseModal"
    />
    <div class="tw-pt-0 tw-p-10 tw-flex tw-flex-col">
      <div class="tw-text-[25px] tw-flex tw-flex-col tw-gap-[10px]">
        <div
          class="tw-font-semibold tw-text-[#211F58] tw-leading-[normal] tw-mb-[15px]"
        >
          {{ title }}
        </div>
      </div>
      <div
        class="tw-text-[15px] tw-flex tw-flex-col tw-gap-[20px] tw-text-[#231F20]"
      >
        <div>
          {{ description }}
          <span class="tw-font-semibold">
            {{
              getComponentUiText(
                "app-assess-recommendations-modal-reorder-note-1",
              )
            }}
          </span>
        </div>
      </div>
      <div class="tw-flex tw-justify-between tw-items-center tw-mt-10">
        <div
          class="tw-flex tw-items-center tw-h-[20px] tw-cursor-pointer"
          @click="updateIsChecked"
        >
          <CustomCheckBox
            :class="`tw-h-[20px] !tw-mb-0 !tw-pl-[35px]`"
            size="20px"
            :is-checked="isChecked"
            @update:is-checked="updateIsChecked"
          />
          <div
            class="tw-text-[13px] tw-font-medium tw-text-[#878787] tw-leading-[nomal]"
          >
            {{
              getComponentUiText(
                "app-assess-recommendations-modal-reorder-button-title-checkbox-1",
              )
            }}
          </div>
        </div>

        <div class="tw-flex">
          <b-button
            style="line-height: 90%; border: 2px solid #387dff; height: 39px"
            variant="primary"
            class="tw-w-fit tw-mr-[15px] tw-shadow-none tw-bg-[#fff] tw-text-[#387DFF] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]"
            type="submit"
            @click="handleCloseModal"
          >
            {{
              getComponentUiText(
                "app-menu-submenu-home-setup-wizard-modal-button-cancel-1",
              )
            }}
          </b-button>
          <b-button
            style="line-height: 90%; height: 39px"
            variant="primary"
            :class="`tw-w-fit tw-shadow-none ${`tw-bg-[#387DFF]`} tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]`"
            type="submit"
            @click="handleUpdateModal"
          >
            {{
              buttonText ??
              getComponentUiText(
                "app-settings-domain-verify-modal-delete-button-1",
              )
            }}
          </b-button>
        </div>
      </div>
    </div>
  </ModalComponent>
</template>

<script setup lang="ts">
import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText } from "@/utils/utilities";
import { ref, watch } from "vue";
import ModalComponent from "@/components/common/modalComponent.vue";
import CustomCheckBox from "@/components/common/customCheckBox.vue";
import { localStorageKey, styleClassContain } from "@/utils/constants";

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  buttonText: {
    type: String as () => string | null,
    required: false,
    default: null,
  },
  show: {
    type: Boolean,
    required: true,
  },
});

let showRef = ref(props.show);
const isChecked = ref(false);

const updateIsChecked = () => {
  isChecked.value = !isChecked.value;
};

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

const emit = defineEmits(["update:show", "update:data"]);
const handleCloseModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};

const handleUpdateModal = () => {
  showRef.value = false;
  localStorage.setItem(
    localStorageKey.isDontShowModalReOrderAction,
    isChecked.value.toString(),
  );
  emit("update:data", showRef.value);
  emit("update:show", showRef.value);
};
</script>
